import { attach, createEvent, forward, createStore, restore } from 'effector-root'
import { requestDeleteModalVisibilityChanged } from '@/pages/common/modals/request-delete/request-delete-modal.model'
import { confirmDeleteModalVisibilityChanged } from '@/pages/common/modals/confirm-delete/confirm-delete-modal.model'
import { RequestDeleteGroups } from '@/pages/users/groups/list/model/types'
import { requestDeleteGroupsFx } from '@/features/api/groups/delete-groups'

export const groupsPageMounted = createEvent<void>()

export const setIsLoading = createEvent<boolean>()
export const $isLoading = restore(setIsLoading, false)

export const requestDeleteGroups = attach({
  effect: requestDeleteGroupsFx,
  mapParams: (payload: RequestDeleteGroups) => {
    return {
      groups: payload.groups,
      ticket_comment: payload.ticket_comment,
    }
  },
})

const needRefresh = createEvent<boolean>()

forward({
  from: requestDeleteGroups.done,
  to: [
    requestDeleteModalVisibilityChanged.prepend(() => false),
    confirmDeleteModalVisibilityChanged.prepend(() => false),
    needRefresh.prepend(() => true),
  ],
})

export const $refreshPage = createStore(false)
  .on(needRefresh, (_, payload) => payload)
  .reset(groupsPageMounted)
